import React from 'react'
import ForgotPassword from '../_components/auth/ForgotPassword'
import "../_css/ResetPassword.css";

function ResetPassword() {
  return (
    <ForgotPassword />
  )
}

export default ResetPassword;